import React, { useState } from 'react';
import styles from 'componets/date-picker/index.module.scss';
import 'componets/date-picker/custom.css';
import classname from 'classnames/bind';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import * as locales from 'react-date-range/dist/locale';
import moment from 'moment';
import { DateIcon, ArrowRightIcon, CloseIcon } from 'icons';

const cx = classname.bind(styles);

const DatePicker = ({
  dateRange = { startAt: undefined, endAt: undefined },
  clearable = true,
  onDateSelected,
  onClickDatePicker,
  isInvalid = false,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [ownDateRange, setOwnDateRange] = useState(dateRange);

  const DateRangeText = () => {
    if (ownDateRange.startAt !== undefined) {
      return (
        <span className={styles.text}>
          {moment.parseZone(ownDateRange.startAt).format('YYYY.MM.DD')}
          <ArrowRightIcon width={20} height={20} className={styles.arrow} />
          {moment.parseZone(ownDateRange.endAt).format('YYYY.MM.DD')}
        </span>
      );
    } else {
      return <span className={`${styles.text} ${styles.unSelected}`}>選擇日期</span>;
    }
  };

  const onClearDateRange = event => {
    event.preventDefault();
    event.stopPropagation();
    const result = {
      startAt: undefined,
      endAt: undefined,
    };
    setOwnDateRange(result);
    onDateSelected(result);
  };

  const ClearItem = () => {
    const clearClasses = cx({
      clear: true,
      visible: clearable && ownDateRange.startAt !== undefined,
    });
    return <CloseIcon width={24} height={24} className={clearClasses} onClick={onClearDateRange} />;
  };

  const onChangeHandler = ({ selection }) => {
    if (selection.startDate !== undefined && selection.endDate !== undefined) {
      const result = {
        startAt: moment
          .parseZone(selection.startDate)
          .startOf('day')
          .toDate(),
        endAt: moment
          .parseZone(selection.endDate)
          .endOf('day')
          .toDate(),
      };
      setOwnDateRange(result);
      onDateSelected(result);
    }
  };
  const onToggleDateRange = () => {
    setShowDropdown(!showDropdown);
  };

  const dateRangeClasses = cx({
    dateRange: true,
    show: showDropdown,
  });

  const maskClasses = cx({
    mask: true,
    visible: showDropdown,
  });

  const inputClasses = cx({
    input: true,
    invalid: isInvalid,
    active: showDropdown,
  });

  return (
    <div className={styles.datePicker}>
      <div
        className={inputClasses}
        onClick={() => {
          onClickDatePicker();
          onToggleDateRange();
        }}
      >
        <DateIcon className={styles.icon} />
        <DateRangeText />
        <ClearItem />
      </div>
      <div className={maskClasses} onClick={onToggleDateRange} />
      <div className={dateRangeClasses}>
        <div className={styles.title}>選擇日期</div>
        <div
          className={styles.close}
          onClick={() => {
            setShowDropdown(false);
          }}
        >
          <CloseIcon />
        </div>
        <DateRange
          locale={locales.zhTW}
          ranges={[
            {
              startDate: ownDateRange.startAt,
              endDate: ownDateRange.endAt,
              key: 'selection',
            },
          ]}
          onChange={onChangeHandler}
          maxDate={new Date()}
        />
        <div
          className={styles.confirm}
          onClick={() => {
            setShowDropdown(false);
          }}
        >
          關閉
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
